<template>
  <div>
    <!--基本信息-->
    <div class="common-form">基本信息</div>
    <el-form-item label="服务名称：" :rules="[{ required: true, message: '请填写服务名称' }]" prop="model.name">
      <el-input v-model="form.model.name" class="max-w460"></el-input>
    </el-form-item>
<!--    <el-form-item label="所属分类：" :rules="[{ required: true, message: '请选择服务分类' }]" prop="model.category_id">-->
<!--      <el-select v-model="form.model.category_id">-->
<!--        <template v-for="cat in form.category">-->
<!--          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>-->
<!--          <template v-if="cat.child !== undefined" v-for="two in cat.child">-->
<!--            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>-->
<!--            <template v-if="two.child !== undefined" v-for="three in two.child">-->
<!--              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>-->
<!--            </template>-->
<!--          </template>-->
<!--        </template>-->
<!--      </el-select>-->
<!--    </el-form-item>-->
    <el-form-item label="价格：" :rules="[{ required: true, message: '请输入价格' }]" prop="model.price">
      <el-input type="number" min="0" v-model="form.model.price" class="max-w230"></el-input>$
    </el-form-item>
    <el-form-item label="销售状态：">
      <el-radio-group v-model="form.model.status">
        <el-radio :label="1">立即上架</el-radio>
        <el-radio :label="2">放入仓库</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="服务排序：" :rules="[{ required: true, message: ' ' }]" prop="model.sort">
      <el-input type="number" min="0" v-model="form.model.sort" class="max-w230"></el-input>
    </el-form-item>
    <el-form-item label="服务图片：" :rules="[{ required: true, message: '请上传服务图片' }]" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div class="item" v-for="(item, index) in form.model.image" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('image', 'image')"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>
    <el-form-item label="服务时长：" :rules="[{ required: true, message: ' ' }]">
      <el-select v-model="form.model.hour" placeholder="请选择">
        <el-option v-for="(item, index) in hour_arr" :key="index" :label="item" :value="item"></el-option>
      </el-select>小时
      <el-select v-model="form.model.minute" placeholder="请选择">
        <el-option v-for="(item, index) in minute_arr" :key="index" :label="item" :value="item"></el-option>
      </el-select>分钟
    </el-form-item>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>

import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      hour_arr: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      minute_arr: [0,5,10,15,20,25,30,35,40,45,50,55],
      isProductUpload: false,
      config: {},
      file_name: 'image'
    };
  },
  inject: ['form'],
  created() {

  },
  methods: {

    /*打开上传图片*/
    openProductUpload: function(file_type, file_name) {
      this.file_name = file_name;
      if(file_type == 'image'){
        this.config = {
          total: 9,
          file_type: 'image'
        };
      }else{
        this.config = {
          total: 1,
          file_type: 'video'
        };
      }
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if(this.file_name == 'video'){
          this.form.model.video_id = e[0].file_id;
          this.form.model.video = e[0];
        }else if(this.file_name == 'image'){
          let imgs = this.form.model.image.concat(e);
          this.$set(this.form.model, 'image', imgs);
        }
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.image.splice(index, 1);
    },
    /*打开添加*/
    setExpress() {
      this.$router.push('/setting/delivery/index');
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/service/service/part/Basic.vue